<div class="package-card">
  <div class="card-header">{{ title }}</div>

  <div class="features">
    <div class="feature" *ngFor="let f of features; trackBy: trackByFeature">{{ f }}</div>
  </div>

  <div class="options">
    <div class="option" *ngFor="let o of options; trackBy: trackByOption" [class.active]="selectedOptionId === o.id" (click)="onSelect(o.id)">
      <div class="row">
        <span class="radio" [class.checked]="selectedOptionId === o.id"></span>
        <div class="text">
          <div class="title">{{ o.label }}</div>
          <ng-container *ngIf="getDescriptionParts(o.description) as d">
            <div class="sub">
              <span class="link">{{ d.left }}</span>
              <span class="dot" *ngIf="d.right">•</span>
              <span class="muted" *ngIf="d.right">{{ d.right }}</span>
            </div>
          </ng-container>
        </div>
        <div class="price">
          <div class="current">{{ o.priceLabel }}</div>
          <div class="original" *ngIf="o.originalPriceLabel">{{ o.originalPriceLabel }}</div>
        </div>
      </div>
      <div class="note" *ngIf="o.note">{{ o.note }}</div>
    </div>
  </div>
</div>


